import { Controller, useFormContext } from 'react-hook-form';

import { FormInput, FormLabel, FormRow } from '@ui/components/Form/Form';
import { Input } from '@ui/components/Input';

import { TournamentEditFormValues } from '@features/tournament/ui/components/TournamentSettings/typings';

export function TitleInput() {
  const { control } = useFormContext<TournamentEditFormValues>();
  return (
    <FormRow>
      <FormLabel>Название</FormLabel>
      <FormInput>
        <Controller
          name="title"
          control={control}
          render={({ field: { value, onChange, disabled } }) => (
            <Input invisible value={value as string} onChange={onChange} disabled={disabled} />
          )}
        />
      </FormInput>
    </FormRow>
  );
}
